export const ORDERS_LOAD = 'ORDERS_LOAD';
export const VIEW_ORDER_LOAD = 'VIEW_ORDER_LOAD';
export const VIEW_ORDER_LOADED = 'VIEW_ORDER_LOADED';
export const ORDER_CANCEL = 'ORDER_CANCEL';
export const ORDER_UPDATE_SUCCESS = 'ORDER_UPDATE_SUCCESS';
export const ORDER_HOLD = 'ORDER_HOLD';
export const ORDER_CANCEL_HOLD = 'ORDER_CANCEL_HOLD';
